<template>
  <div class="flex items-center justify-between px-6 py-4 border-t border-gray-100">
    <span class="text-xs text-gray-400 font-medium tracking-wide">
      Page
      <span class="text-gray-600 font-semibold">{{
        totalPages === 0 ? 0 : currentPage
      }}</span>
      of
      <span class="text-gray-600 font-semibold">{{ totalPages }}</span>
    </span>

    <div class="flex items-center gap-2">
      <button :disabled="currentPage === 1 || totalPages === 0" @click="$emit('page-changed', currentPage - 1)"
        class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-sm font-medium transition-all duration-200"
        :class="currentPage === 1 || totalPages === 0
          ? 'text-gray-300 bg-gray-50 cursor-not-allowed border border-gray-100'
          : 'text-gray-600 bg-white border border-gray-200 hover:border-[#F48921] hover:text-[#F48921] hover:shadow-sm'
          ">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        Previous
      </button>

      <button :disabled="currentPage === totalPages || totalPages === 0" @click="$emit('page-changed', currentPage + 1)"
        class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-sm font-medium transition-all duration-200"
        :class="currentPage === totalPages || totalPages === 0
          ? 'text-gray-300 bg-gray-50 cursor-not-allowed border border-gray-100'
          : 'text-white bg-[#F48921] border border-[#F48921] hover:bg-[#d97b1b] hover:border-[#d97b1b] hover:shadow-sm'
          ">
        Next
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
  },
};
</script>
